export const Deleteicon = ({
  color = "#8e8e8e",
  width = "17.073",
  height = "23.135",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17.073 23.135"
      {...props}
      style={{ color, ...props.style }}
    >
      <g id="Group_2007" data-name="Group 2007" transform="translate(0 1)">
        <g id="Group_2006" data-name="Group 2006">
          <path
            id="Path_6219"
            data-name="Path 6219"
            d="M64,99.344a2.411,2.411,0,0,0,2.482,2.335H76.41a2.411,2.411,0,0,0,2.482-2.335V85.333H64Z"
            transform="translate(-62.832 -79.543)"
            fill="currentColor"
          />
          <path
            id="Path_6220"
            data-name="Path 6220"
            d="M55.472,1.9,54.252,0h-6.1l-1.22,1.9H42.667V5.69H59.74V1.9Z"
            transform="translate(-42.667 -1)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
